import SliderField from './SliderField';

export {
    SliderField
};

export default SliderField;
